import React, { useState, useMemo } from "react";
import { tableContainerBigger, tableBase, tableHead, tableHeader, tableCell, tableRow } from '../../../utils/tableStyle';
import Pagination from "../../CommonComponents/Pagination";
import SearchInput from "../../CommonComponents/SearchInput";

const ProductSalesTable = ({ products }) => {
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const pageSize = 10;

    // Filter and sort products
    const filteredProducts = useMemo(() => {
        let filtered = products;
        if (search.trim()) {
            const s = search.trim().toLowerCase();
            filtered = filtered.filter(
                p => (p.product?.name || p.product || p.product_id || "").toString().toLowerCase().includes(s)
            );
        }
        return filtered.sort((a, b) => parseInt(b.totalQty) - parseInt(a.totalQty));
    }, [products, search]);

    const totalPages = Math.ceil(filteredProducts.length / pageSize);
    const paginated = filteredProducts.slice((page - 1) * pageSize, page * pageSize);

    // Reset to first page if search or products change and current page is out of range
    React.useEffect(() => {
        if (page > totalPages) setPage(1);
    }, [search, products, totalPages]);

    return (
        <div className={tableContainerBigger + " shadow p-6 flex flex-col w-full"}>
            <div className="flex items-center justify-between mb-4">
                <div>
                    <h2 className="text-lg font-semibold text-gray-800">All Products Sold</h2>
                    <div className="text-xs text-gray-500 mt-1">Sorted from most to least sold</div>
                </div>
                <div className="w-64">
                    <SearchInput value={search} onChange={e => { setSearch(e.target.value); setPage(1); }} placeholder="Search product..." />
                </div>
            </div>
            <div className="overflow-x-auto mb-3">
                <table className={tableBase}>
                    <thead
                        className={tableHead}
                        style={{ background: 'var(--color-primary)' }}
                    >
                        <tr>
                            <th className={tableHeader + ' rounded-tl-lg'}>#</th>
                            <th className={tableHeader}>Product</th>
                            <th className={tableHeader + ' rounded-tr-lg'}>Quantity Sold</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginated.length === 0 ? (
                            <tr><td colSpan={3} className={tableCell + ' text-center text-gray-400'}>No products found.</td></tr>
                        ) : paginated.map((p, idx) => (
                            <tr key={p.product_id || p.product?.id || idx} className={tableRow}>
                                <td className={tableCell}>{(page - 1) * pageSize + idx + 1}</td>
                                <td className={tableCell}>{p.product?.name || p.product || p.product_id}</td>
                                <td className={tableCell}>{p.totalQty}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <Pagination
                currentPage={page}
                totalPages={totalPages}
                onPageChange={setPage}
                totalCount={filteredProducts.length}
            />
        </div>
    );
};

export default ProductSalesTable;
